module.exports = __webpack_public_path__ + "img/exclusive_01.7f3780a8.jpg";